import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "index",
    meta: {
      title: "首页",
    },
    component: () => import("../views/index.vue"),
  },
  // {
  //   path: "/",
  //   name: "login",
  //   meta: {
  //     title: "登录",
  //   },
  //   component: () => import("../views/login.vue"),
  // },
  {
    path: "/moca",
    name: "moca",
    component: () => import("../views/moca.vue"),
  },
  {
    path: "/mmse",
    name: "mmse",
    component: () => import("../views/mmse.vue"),
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("../views/setting.vue"),
  },
  {
    path: "/user",
    name: "user",
    meta: {
      title: "个人档案",
    },
    component: () => import("../views/user.vue"),
  },
  {
    path: "/customized",
    name: "customized",
    meta: {
      title: "量表定制",
    },
    component: () => import("../views/customized.vue"),
  },
  {
    path: "/makCustom",
    name: "makCustom",
    meta: {
      title: "制作量表",
    },
    component: () => import("../views/makCustom.vue"),
  },
  {
    path: "/testPage",
    name: "testPage",
    meta: {
      title: "testPage",
    },
    component: () => import("../views/testPage.vue"),
  },
  {
    path: "/audioAnalysis",
    name: "audioAnalysis",
    meta: {
      title: "audioAnalysis",
    },
    component: () => import("../views/audioAnalysis.vue"),
  },
  {
    path: "/tamplateData",
    name: "tamplateData",
    meta: {
      title: "tamplateData",
    },
    component: () => import("../views/tamplateData.vue"),
  },
  {
    path: "/mmcgd",
    name: "mmcgd",
    meta: {
      title: "mmcgd",
    },
    component: () => import("../views/mmcgdmd.vue"),
  },
  {
    path: "/mmcgdmd",
    name: "mmcgdmd",
    meta: {
      title: "mmcgdmd",
    },
    component: () => import("../views/mmcgdmd.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
